import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "question-menu mb-3 d-flex align-center" }
const _hoisted_3 = { class: "question-box me-4" }
const _hoisted_4 = { class: "question-num" }
const _hoisted_5 = {
  key: 0,
  class: "date"
}
const _hoisted_6 = { class: "votes d-flex align-center" }
const _hoisted_7 = {
  key: 1,
  class: "author d-flex align-center"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-center py-10"
}

import { ref, watch, onMounted, onUnmounted } from 'vue'
import api from '../../../api/v2/api'
import UserQuestion from '../../../api/v2/models/user_question'
import Pagination from '../../../api/v2/models/pagination'
import UserQuestionDialog from '../organisms/UserQuestionDialog.vue'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import { eventBus, EVENTS } from '../../utils/eventBus'

// Reactive Data

export default /*@__PURE__*/_defineComponent({
  __name: 'UserQuestionMyList',
  setup(__props) {

const questions = ref<UserQuestion[]>([])
const pagination = ref<Pagination | null>(null)
const isLoading = ref(true)
const search = ref('')
const mobile = ref(checkMobile())
const showSideBar = ref(false)

// Functions
async function selectPage(page: number) {
  try {
    [pagination.value, questions.value] = await api.userQuestion.my({ page: page, search: search.value })
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch(e) {
    // Error handling
  }
}

async function getList() {
  try {
    isLoading.value = true
    ;[pagination.value, questions.value] = await api.userQuestion.my({ page: 1, search: search.value })
  } catch(e) {
    // Error handling
  } finally {
    isLoading.value = false
  }
}

// Watchers
watch(search, async () => {
  getList()
})

// Lifecycle
onMounted(() => {
  eventBus.on(EVENTS.QUESTION_CREATED, getList)
})

onUnmounted(() => {
  eventBus.off(EVENTS.QUESTION_CREATED, getList)
})

// Created logic
headerState.setTitle('マイ質問一覧')
getList()

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcrumb, { items: [
      { text: 'クラスルーム', to: '/classroom/' },
      { text: 'マイ質問一覧' }
    ] }),
    _createCommentVNode(" Main content "),
    _createVNode(_component_v_row, {
      class: "ma-0",
      style: { minHeight: '700px' }
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" Main column: Question list "),
        _createVNode(_component_v_col, {
          cols: "12",
          lg: "12",
          class: "pt-0 bg-white"
        }, {
          default: _withCtx(() => [
            _createCommentVNode(" Tabs "),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_col, {
                lg: "10",
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tab, null, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("マイ質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_tab, { to: "/classroom/questions" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("みんなの質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_tab, { to: "/classroom/my-answer-questions" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("アンサーした質問", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              (!mobile.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    lg: "2",
                    class: "text-end pa-0 pe-2 d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(UserQuestionDialog)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Search bar row "),
            _createVNode(_component_v_row, {
              class: "align-center px-3 py-2",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "8",
                  md: "9"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      placeholder: "キーワードを入力してください",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  md: "3",
                  class: "d-flex justify-end align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "outlined",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (search.value = ''))
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("クリア", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Loading skeleton "),
            (isLoading.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(Array.from(Array(10).keys()), (item, index) => {
                  return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: index,
                    ref_for: true,
                    ref: "skeleton",
                    type: "list-item-avatar-three-line",
                    class: "mx-auto"
                  }))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Question list "),
            (!isLoading.value)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 1,
                  class: "question-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `question-${question.id}`
                      }, [
                        _createVNode(_component_v_list_item, {
                          to: `/classroom/questions/${question.id}`,
                          class: "question-item py-3"
                        }, {
                          prepend: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, _toDisplayString(question.answersCount), 1 /* TEXT */),
                              _createElementVNode("div", {
                                class: _normalizeClass({'question-active' : question.answersCount > 0, 'question-deactive' : question.answersCount == 0 })
                              }, " Ans ", 2 /* CLASS */)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "question-title mb-1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(question.title) + " ", 1 /* TEXT */),
                                (question.questionType == 'private_question')
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      size: "small",
                                      color: "orange",
                                      class: "ms-2"
                                    }, {
                                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode(" プライベート ", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createVNode(_component_v_list_item_subtitle, { class: "question-meta d-flex align-center flex-wrap gap-3" }, {
                              default: _withCtx(() => [
                                (question.createdAt)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(question.createdAt.substring(0, 10)), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("span", _hoisted_6, [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    class: "me-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createTextVNode("mdi-thumb-up-outline", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createTextVNode(" " + _toDisplayString(question.voteValues), 1 /* TEXT */)
                                ]),
                                (question.user)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                      (question.user.image)
                                        ? (_openBlock(), _createBlock(_component_v_avatar, {
                                            key: 0,
                                            size: "20",
                                            class: "me-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", {
                                                src: question.user.image.url
                                              }, null, 8 /* PROPS */, _hoisted_8)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1024 /* DYNAMIC_SLOTS */))
                                        : _createCommentVNode("v-if", true),
                                      (question.user.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(question.user.name), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                        _createVNode(_component_v_divider)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Empty state "),
            (!isLoading.value && questions.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_v_icon, {
                    size: "64",
                    color: "grey-lighten-1"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-help-circle-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-grey mt-4" }, "まだ質問がありません", -1 /* CACHED */)),
                  (!mobile.value)
                    ? (_openBlock(), _createBlock(UserQuestionDialog, { key: 0 }))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Pagination "),
            (questions.value.length > 0 && pagination.value && pagination.value.totalPages > 1)
              ? (_openBlock(), _createBlock(_component_v_pagination, {
                  key: 3,
                  modelValue: pagination.value.page,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((pagination.value.page) = $event)),
                    selectPage
                  ],
                  length: pagination.value.totalPages,
                  class: "mt-4 mb-5"
                }, null, 8 /* PROPS */, ["modelValue", "length"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Mobile footer with create button "),
    (mobile.value)
      ? (_openBlock(), _createBlock(_component_v_footer, {
          key: 0,
          app: "",
          class: "bg-white elevation-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { class: "text-center py-2" }, {
              default: _withCtx(() => [
                _createVNode(UserQuestionDialog)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})